import { cl } from '../common/functions';

const historyReplace = () => {
  if (window.history.replaceState) {
    window.history.replaceState(null, null, window.location.href);
  }
}

export { historyReplace };
